import { useEffect, useState } from 'react';
import { useStore } from 'src/contexts/StoreContext';
import { useAddToCartHandlers } from 'src/hooks/useAddToCartHandlers';
import { SAVING_STATE } from 'src/store/page-project/pageProject.constants';
import { useActiveProjectPrices } from 'src/hooks/useActiveProjectPrices';

export const useHeaderV3 = () => {
  const { i18n, project } = useStore();

  const { estimatePrice, originalPrice } = useActiveProjectPrices();

  const isNoProducts = project.totalNumberOfProducts === 0;

  const SaveButtonTexts = {
    [SAVING_STATE.saving]: '',
    [SAVING_STATE.saved]: i18n.t('header:saved'),
    [SAVING_STATE.toBeSaved]: i18n.t('header:save'),
  };

  const [saveButtonText, setSaveButtonText] = useState<string>('');
  const [saveButtonTextVisible, setSaveButtonTextVisible] = useState<boolean>(false);
  const [isProjectSaved, setIsProjectSaved] = useState<boolean>(false);

  useEffect(() => {
    if (project.activeProject!.savingState !== SAVING_STATE.saving) setSaveButtonTextVisible(true);
    setSaveButtonText(SaveButtonTexts[project.activeProject!.savingState]);
    if (project.activeProject!.savingState === SAVING_STATE.saved) {
      setTimeout(() => {
        setSaveButtonTextVisible(false);
      }, 2000);
    }
  }, [project.activeProject!.savingState]);

  const { handleAddToCart, handleClickAddToCart } = useAddToCartHandlers(true);

  return {
    isNoProducts,
    estimatePrice,
    originalPrice,
    saveButtonText,
    saveButtonTextVisible,
    setSaveButtonText,
    SaveButtonTexts,
    handleAddToCart,
    handleClickAddToCart,
    isProjectAddedToCart: project.isProjectAddedToCart,
    totalNumberOfProducts: project.activeProject?.priceDetails?.totalItems ?? 0,
    addProducts: project.addProducts,
    isProjectSaved,
    setIsProjectSaved,
  };
};
